import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import includes from 'lodash/includes';

import events, { EVENT_DASHBOARD_LOADED } from '../../lib/events';
import Purchase from '../../lib/purchase';
import { AUTHORIZING } from '../../lib/payment-statuses';

import PurchaseDashboardComponent from '../../components/purchase-dashboard/index';
import { getMemberships } from '../../selectors/purchase-selector';
import {
  fetchPurchase,
  setCommitFormVersion,
  fetchPurchaseMemberships,
  fetchPurchaseActivities,
  DASHBOARD_COMMIT
} from '../../actions';

import withDashboardProjectionFetcher from '../../../components/hoc/with-dashboard-projection-fetcher';

class PurchaseDashboard extends Component {
  static propTypes = {
    fetchDashboardProjection: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.reloadAuthorizingPayment = this.reloadAuthorizingPayment.bind(this);
  }

  componentWillMount() {
    const {
      match,
      fetchPurchaseMemberships,
      setCommitFormVersion,
      purchase,
      fetchDashboardProjection,
      fetchPurchaseActivities,
      authentication,
    } = this.props;
    const slug = match.params.id;

    fetchPurchaseMemberships(slug, purchase.memberships.length);
    setCommitFormVersion(DASHBOARD_COMMIT);
    fetchDashboardProjection();
    fetchPurchaseActivities(purchase.id, authentication);

  }

  componentDidMount() {
    const {
      purchase, authentication, renderedLanguage, memberships, currentMembership,
    } = this.props;
    const membershipId = includes(memberships.map(m => m.id), currentMembership) ?
     currentMembership : undefined;
    const data = {
      browserLanguage: navigator.language,
      renderedLanguage,
      membershipId,
    };
    events.publish(EVENT_DASHBOARD_LOADED, {
      entityId: purchase.id,
      entityType: 'Purchase',
    },
      data,
      authentication,
    );
    setTimeout(this.reloadAuthorizingPayment, 15000);
  }

  reloadAuthorizingPayment() {
    const payment = Purchase.getCurrentOrLastPayment(this.props.purchase);
    if (payment.status === AUTHORIZING) {
      window.location.reload();
    }
  }

  render() {
    const { purchase } = this.props;

    return (
      <PurchaseDashboardComponent
        user={this.props.user}
        purchase={purchase}
        memberships={this.props.memberships}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const { users } = state;

  return {
    user: users.byId[users.current],
    memberships: getMemberships(state),
    currentMembership: state.memberships.current,
    authentication: state.session.authentication,
    renderedLanguage: state.session.language,
  };
};

const mapDispatchToProps = {
  fetchPurchase,
  setCommitFormVersion,
  fetchPurchaseMemberships,
  fetchPurchaseActivities,
};

export default compose(
  withDashboardProjectionFetcher,
  connect(mapStateToProps, mapDispatchToProps)
)(PurchaseDashboard);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-dashboard/index.container.js